angular.module('leanlaw').controller('ClientMatterCustomFlagCtrl', ['$scope', '$rootScope', '$q', '$filter', '$timeout', '$stateParams', '$state', "alerts", 'userService', 'reportsService', 'commonFilterService', "exportJson", "singleRequest", "messageBus", function ($scope, $rootScope, $q, $filter, $timeout, $stateParams, $state, alerts, userService, reportsService, commonFilterService, exportJson, singleRequest, messageBus) {
  $scope.clients = {};
  $scope.filter = {};
  $scope.search = "";
  $scope.format = {};
  $scope.sort = ['client.label', 'matter.label'];
  $scope.reverse = false;
  $scope.print = function () {
    window.print();
  };
  $scope.export = function () {
    const matter = $scope.me.terms.Matter;
    const customFlagLabel = $scope.customFlagLabel;
    const exp = $scope.data.filteredClients.reduce((accum, c) => {
      if ($scope.clientReferences || $scope.references) {
        if ($scope.filter.include && $scope.filter.include.matters) {
          accum.push({
            "ID": c.client.reference || "",
            "Client": c.client.name,
            [matter]: "",
            [customFlagLabel]: $filter("amount")(c.data.customFlagAmounts.total),
            [`Not ${customFlagLabel}`]: $filter("amount")(c.data.customFlagAmounts.none),
            "Total": $filter("amount")(c.data.amounts.total)
          });
        } else {
          accum.push({
            "ID": c.client.reference || "",
            "Client": c.client.name,
            [customFlagLabel]: $filter("amount")(c.data.customFlagAmounts.total),
            [`Not ${customFlagLabel}`]: $filter("amount")(c.data.customFlagAmounts.none),
            "Total": $filter("amount")(c.data.amounts.total)
          });
        }
      } else if ($scope.filter.include && $scope.filter.include.matters) {
        accum.push({
          "ID": c.client.reference || "",
          "Client": c.client.name,
          [matter]: "",
          [customFlagLabel]: $filter("amount")(c.data.customFlagAmounts.total),
          [`Not ${customFlagLabel}`]: $filter("amount")(c.data.customFlagAmounts.none),
          "Total": $filter("amount")(c.data.amounts.total)
        });
      } else {
        accum.push({
          "Client": c.client.name,
          [customFlagLabel]: $filter("amount")(c.data.customFlagAmounts.total),
          [`Not ${customFlagLabel}`]: $filter("amount")(c.data.customFlagAmounts.none),
          "Total": $filter("amount")(c.data.amounts.total)
        });
      }
      if ($scope.filter.include && $scope.filter.include.matters) {
        c.matters.forEach(m => {
          accum.push({
            "ID": m.matter.reference ? !isNaN(m.matter.reference) ? `="${m.matter.reference}"` : m.matter.reference : '',
            "Client": "",
            [matter]: m.matter.name,
            [customFlagLabel]: $filter("amount")(m.data.customFlagAmounts.total),
            [`Not ${customFlagLabel}`]: $filter("amount")(m.data.customFlagAmounts.none),
            "Total amount": $filter("amount")(m.data.amounts.total)
          });
        });
      }
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };
  $scope.loading = true;
  userService.me().then(me => {
    $scope.trust = me.company.settings.trustEnabled;
    $scope.customFlagLabel = me.company.settings.labels && me.company.settings.labels.customFlag;
    $scope.$on('commonFilterService-statechanged', (event, payload) => {
      if (!payload) return;
      // Assigning to existing filter keeps custom filter options
      $scope.filter = Object.assign($scope.filter, payload);
      // Necessary to set this value for the requests
      $scope.filter.status = $scope.filter.archived.status;
      $scope.filter.scope = $scope.filter.filter.scope;
      // if (payload.filter.range) filterClientEntries();
      filterClientEntries();
    });
    $scope.$on("report-sidebar-filterchange", (event, payload) => {
      $scope.filter = Object.assign($scope.filter, payload);
    });
    $scope.$on("report-clientmatter-change", (event, cm) => {
      singleRequest.cancel("clientEntries");
      $scope.goToSummary(cm.client ? cm.client.id : null, cm.matter ? cm.matter.id : null);
    });
    $scope.$watch('filter.include.accounting', show => {
      if (show) {
        filterClientEntries();
      }
    }, true);

    // MessageBus is used here so that the commonFilter module can pick it up once it loads
    messageBus.addMessage("filterDependency-ready", true);
    messageBus.addMessage("clientmatter-set", true, {});
  });
  function update(data) {
    data.data.customFlagAmounts.none = Math.round((data.data.amounts.total - data.data.customFlagAmounts.total) * 100) / 100;
    const loop = data.clients || data.matters;
    if (loop) {
      loop.forEach(update);
    }
  }
  function filterClientEntries() {
    $scope.loading = true;
    $scope.data = null;
    const query = angular.copy($scope.filter);
    query.data = "services,expenses,charges,customFlag";
    query.billed = "true";
    query.billedState = undefined;
    singleRequest.serviceCall("customflag", reportsService.getClientReport)(query).then(data => {
      if (!data) return;
      $scope.data = data;
      $scope.references = data.clients.some(c => c.matters.some(m => m.matter.reference));
      $scope.clientReferences = data.clients.some(c => c.client.reference);
      update($scope.data);
      $scope.loading = false;
    }).catch(err => {
      alerts.error(err);
      $scope.loading = false;
    });
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("customflag");
    deactivate();
  });

  // MatterId may be optional
  $scope.goToSummary = function (clientId, matterId) {
    $state.go("reports.client-summary", {
      clientId,
      matterId,
      return: "reports.client-matter-billables",
      report: `Client and ${$scope.me.terms.Matter} Billables`
    });
  };

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.data) return;
    $scope.data.filteredClients = $filter('orderBy')($filter('filter')($scope.data.clients, $scope.search), $scope.sort, $scope.reverse) || [];
    $scope.data.filteredClients.forEach(client => {
      client.filteredMatters = $filter('orderBy')($filter('filter')(client.matters, $scope.q), $scope.sort, $scope.reverse) || [];
    });
  }
  $scope.$watch('data.clients', updateFiltered);
  $scope.$watch('search', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);